import { render, staticRenderFns } from "./show.page.vue?vue&type=template&id=e07e54a6&scoped=true&"
import script from "./show.page.vue?vue&type=script&lang=ts&"
export * from "./show.page.vue?vue&type=script&lang=ts&"
import style0 from "./show.page.vue?vue&type=style&index=0&id=e07e54a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07e54a6",
  null
  
)

export default component.exports